import * as React from "react";
import { SVGProps } from "react";
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.004 6.499a1 1 0 0 1 .993.883l.007.117v15.13c1.95-1.644 4.032-3.882 6.207-6.677a.996.996 0 0 1 1.403-.175 1 1 0 0 1 .175 1.403c-2.727 3.505-5.341 6.19-7.767 7.983a1.712 1.712 0 0 1-2.044-.001c-2.425-1.79-5.039-4.476-7.767-7.982a1 1 0 1 1 1.578-1.228c2.179 2.798 4.264 5.04 6.215 6.682V7.5a1 1 0 0 1 1-1v-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowDown;
